module.exports = __webpack_public_path__ + "img/pic-key.964b43f.svg";